"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_AFFILIATION_SCALE_TITLE_KR = exports.EN_AFFILIATION_SCALE_TYPE = exports.EN_AFFILIATION_SCALE_ABBR_CODE = exports.EN_AFFILIATION_SCALE_CODE = void 0;
/**
 * 직영, 가맹점이 어느정도 규모인지 표현한다. 투자비용 및 객실 수 등에 영향을 주며 앱에서는
 * 마커가 달라지는 등의 차이가 있다.
 */
var EN_AFFILIATION_SCALE_CODE;
(function (EN_AFFILIATION_SCALE_CODE) {
    /** 알수없음, 모름. 비제휴점인 경우 */
    EN_AFFILIATION_SCALE_CODE[EN_AFFILIATION_SCALE_CODE["UNKNOWN"] = -1] = "UNKNOWN";
    /** 야자: 일반 모텔규모 */
    EN_AFFILIATION_SCALE_CODE[EN_AFFILIATION_SCALE_CODE["YAJA"] = 1] = "YAJA";
    /** 앤: 부띠끄 호텔 규모(없어졌다...브렌드 종료란다...) */
    EN_AFFILIATION_SCALE_CODE[EN_AFFILIATION_SCALE_CODE["ANNE"] = 2] = "ANNE";
    /** 에비뉴: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_CODE[EN_AFFILIATION_SCALE_CODE["AVENUE"] = 3] = "AVENUE";
    /** 얌: 여관급 제일 작음 */
    EN_AFFILIATION_SCALE_CODE[EN_AFFILIATION_SCALE_CODE["YAM"] = 4] = "YAM";
    /** 코텔: 준 호텔급 */
    EN_AFFILIATION_SCALE_CODE[EN_AFFILIATION_SCALE_CODE["KOTEL"] = 5] = "KOTEL";
})(EN_AFFILIATION_SCALE_CODE = exports.EN_AFFILIATION_SCALE_CODE || (exports.EN_AFFILIATION_SCALE_CODE = {}));
var EN_AFFILIATION_SCALE_ABBR_CODE;
(function (EN_AFFILIATION_SCALE_ABBR_CODE) {
    /** 야자: 일반 모텔규모 */
    EN_AFFILIATION_SCALE_ABBR_CODE["YAJA"] = "Y";
    /** 앤: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_ABBR_CODE["ANNE"] = "R";
    /** 에비뉴: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_ABBR_CODE["AVENUE"] = "H";
    /** 얌: 여관급 제일 작음 */
    EN_AFFILIATION_SCALE_ABBR_CODE["YAM"] = "M";
})(EN_AFFILIATION_SCALE_ABBR_CODE = exports.EN_AFFILIATION_SCALE_ABBR_CODE || (exports.EN_AFFILIATION_SCALE_ABBR_CODE = {}));
var EN_AFFILIATION_SCALE_TYPE;
(function (EN_AFFILIATION_SCALE_TYPE) {
    EN_AFFILIATION_SCALE_TYPE["UNKNOWN"] = "UNKNOWN";
    /** 야자: 일반 모텔규모 */
    EN_AFFILIATION_SCALE_TYPE["YAJA"] = "YAJA";
    /** 앤: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_TYPE["ANNE"] = "ANNE";
    /** 에비뉴: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_TYPE["AVENUE"] = "AVENUE";
    /** 얌: 여관급 제일 작음 */
    EN_AFFILIATION_SCALE_TYPE["YAM"] = "YAM";
    /** 코텔: 준 호텔급 */
    EN_AFFILIATION_SCALE_TYPE["KOTEL"] = "KOTEL";
})(EN_AFFILIATION_SCALE_TYPE = exports.EN_AFFILIATION_SCALE_TYPE || (exports.EN_AFFILIATION_SCALE_TYPE = {}));
var EN_AFFILIATION_SCALE_TITLE_KR;
(function (EN_AFFILIATION_SCALE_TITLE_KR) {
    EN_AFFILIATION_SCALE_TITLE_KR["UNKNOWN"] = "\uC54C\uC218\uC5C6\uC74C";
    /** 야자: 일반 모텔규모 */
    EN_AFFILIATION_SCALE_TITLE_KR["YAJA"] = "\uC57C\uC790";
    /** 앤: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_TITLE_KR["ANNE"] = "\uC564";
    /** 에비뉴: 부띠끄 호텔 규모 */
    EN_AFFILIATION_SCALE_TITLE_KR["AVENUE"] = "\uC5D0\uBE44\uB274";
    /** 얌: 여관급 제일 작음 */
    EN_AFFILIATION_SCALE_TITLE_KR["YAM"] = "\uC58C";
    /** 코텔: 준 호텔급 */
    EN_AFFILIATION_SCALE_TITLE_KR["KOTEL"] = "\uCF54\uD154";
})(EN_AFFILIATION_SCALE_TITLE_KR = exports.EN_AFFILIATION_SCALE_TITLE_KR || (exports.EN_AFFILIATION_SCALE_TITLE_KR = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRU5fQUZGSUxJQVRJT05fU0NBTEUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvc2FwcG9yby9jb25zdGFudC9lbnVtL2FkdmVydGlzZS9FTl9BRkZJTElBVElPTl9TQ0FMRS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7O0dBR0c7QUFDSCxJQUFZLHlCQWFYO0FBYkQsV0FBWSx5QkFBeUI7SUFDbkMseUJBQXlCO0lBQ3pCLGdGQUFZLENBQUE7SUFDWixrQkFBa0I7SUFDbEIseUVBQVEsQ0FBQTtJQUNSLHVDQUF1QztJQUN2Qyx5RUFBUSxDQUFBO0lBQ1IscUJBQXFCO0lBQ3JCLDZFQUFVLENBQUE7SUFDVixtQkFBbUI7SUFDbkIsdUVBQU8sQ0FBQTtJQUNQLGdCQUFnQjtJQUNoQiwyRUFBUyxDQUFBO0FBQ1gsQ0FBQyxFQWJXLHlCQUF5QixHQUF6QixpQ0FBeUIsS0FBekIsaUNBQXlCLFFBYXBDO0FBRUQsSUFBWSw4QkFTWDtBQVRELFdBQVksOEJBQThCO0lBQ3hDLGtCQUFrQjtJQUNsQiw0Q0FBVSxDQUFBO0lBQ1YsbUJBQW1CO0lBQ25CLDRDQUFVLENBQUE7SUFDVixxQkFBcUI7SUFDckIsOENBQVksQ0FBQTtJQUNaLG1CQUFtQjtJQUNuQiwyQ0FBUyxDQUFBO0FBQ1gsQ0FBQyxFQVRXLDhCQUE4QixHQUE5QixzQ0FBOEIsS0FBOUIsc0NBQThCLFFBU3pDO0FBRUQsSUFBWSx5QkFZWDtBQVpELFdBQVkseUJBQXlCO0lBQ25DLGdEQUFtQixDQUFBO0lBQ25CLGtCQUFrQjtJQUNsQiwwQ0FBYSxDQUFBO0lBQ2IsbUJBQW1CO0lBQ25CLDBDQUFhLENBQUE7SUFDYixxQkFBcUI7SUFDckIsOENBQWlCLENBQUE7SUFDakIsbUJBQW1CO0lBQ25CLHdDQUFXLENBQUE7SUFDWCxnQkFBZ0I7SUFDaEIsNENBQWUsQ0FBQTtBQUNqQixDQUFDLEVBWlcseUJBQXlCLEdBQXpCLGlDQUF5QixLQUF6QixpQ0FBeUIsUUFZcEM7QUFFRCxJQUFZLDZCQVlYO0FBWkQsV0FBWSw2QkFBNkI7SUFDdkMscUVBQWdCLENBQUE7SUFDaEIsa0JBQWtCO0lBQ2xCLHNEQUFXLENBQUE7SUFDWCxtQkFBbUI7SUFDbkIsZ0RBQVUsQ0FBQTtJQUNWLHFCQUFxQjtJQUNyQiw4REFBYyxDQUFBO0lBQ2QsbUJBQW1CO0lBQ25CLCtDQUFTLENBQUE7SUFDVCxnQkFBZ0I7SUFDaEIsdURBQVksQ0FBQTtBQUNkLENBQUMsRUFaVyw2QkFBNkIsR0FBN0IscUNBQTZCLEtBQTdCLHFDQUE2QixRQVl4QyJ9